export enum OrderCancellationChargeParty {
  NONE = 'none',
  SENDER = 'sender',
  OUR_COMPANY = 'our-company',
  CONTRACTOR = 'contractor',
}
